import React from "react";
import pluralize from "pluralize";
import PropTypes from "prop-types";
import Currency from "../Currency";

import styles from "./style.module.scss";

const GarmentPrice = ({ garmentName, price }) => (
  <span className={styles.garmentPriceContainer}>
    {`Bespoke ${pluralize(garmentName.toLowerCase())}`}
    <span className={styles.spacer} />
    <span className={styles.garmentPricePrice}>
      <i>from</i>{" "}
      <strong>
        <Currency number={price} />
      </strong>
    </span>
  </span>
);

GarmentPrice.propTypes = {
  garmentName: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired
};

export default GarmentPrice;
